import { render, staticRenderFns } from "./outcomeOptions.vue?vue&type=template&id=dbd31474&scoped=true"
import script from "./outcomeOptions.vue?vue&type=script&lang=js"
export * from "./outcomeOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd31474",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg});qInstall(component, 'directives', {Ripple});
